import { Button } from '@/shared/components/ui/button'
import { AlertCircle, FileText, Plus, RefreshCw } from 'lucide-react'
import React from 'react'
import { FeatureHeader } from '@/shared/components/custom/FeatureHeader'

interface ShotListHeaderProps {
    sceneName: string
    shotCount: number
    showScenePreview: boolean
    setShowScenePreview: (show: boolean) => void
    setIsAIDialogOpen: (open: boolean) => void
    setIsAddDialogOpen: (open: boolean) => void
    error: string | null
    hasShots: boolean
    onAddShot: () => void
}

const ShotListHeader = ({
    sceneName,
    shotCount,
    showScenePreview,
    setShowScenePreview,
    setIsAIDialogOpen,
    setIsAddDialogOpen,
    error,
    hasShots,
    onAddShot
}: ShotListHeaderProps) => {
    return (
        <FeatureHeader
            className="p-6 pb-0"
            title={sceneName}
            subtitle={`${shotCount} Shots`}
            actions={
                <><Button size="sm" onClick={onAddShot}>
                    <Plus className="h-4 w-4 mr-2" />
                    Add Shot
                </Button>

                    {hasShots && <Button size="sm" onClick={() => setIsAIDialogOpen(true)}>
                        <RefreshCw className="h-4 w-4 mr-2" />
                        Regenerate
                    </Button>}

                    {!showScenePreview && (
                        <Button variant="outline" size="sm" onClick={() => setShowScenePreview(true)} title="Show Script">
                            <FileText className="h-4 w-4 mr-2" />
                            Show Script
                        </Button>
                    )}

                </>
            }
        >
            {error && (
                <div className="flex items-center gap-2 text-destructive bg-destructive/10 p-3 rounded-md mt-4">
                    <AlertCircle className="h-4 w-4" />
                    <span className="text-sm">{error}</span>
                </div>
            )}
        </FeatureHeader>
    )
}

export default ShotListHeader
